export const NOTIFICATION_TEXT = {
  /** 읽지 않은 알림의 보조 글자(불투명도만으로 구분하지 않는다) */
  unread: '읽지 않음',
  read: '읽음',
} as const;
